'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlaybackEventNotifier = function (_Component) {
  _inherits(PlaybackEventNotifier, _Component);

  function PlaybackEventNotifier(props) {
    _classCallCheck(this, PlaybackEventNotifier);

    var _this = _possibleConstructorReturn(this, (PlaybackEventNotifier.__proto__ || Object.getPrototypeOf(PlaybackEventNotifier)).call(this, props));

    _initialiseProps.call(_this);

    _this.resetLogging();
    return _this;
  }

  _createClass(PlaybackEventNotifier, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('beforeunload', this.onCommunityVideoStop);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currentTimeMs = nextProps.currentTimeMs,
          logData = nextProps.logData,
          adPlaying = nextProps.adPlaying,
          durationMs = nextProps.durationMs,
          communityContentVideoPlay = nextProps.communityContentVideoPlay,
          communityContentEnterView = nextProps.communityContentEnterView,
          communityContentVideoPositionUpdated = nextProps.communityContentVideoPositionUpdated,
          communityContentId = nextProps.communityContentId,
          playerId = nextProps.playerId,
          trackInViewVideo = nextProps.trackInViewVideo,
          paused = nextProps.paused;


      if (!communityContentId) {
        return;
      }

      if (!this.hasLoggedStart) {
        this.hasLoggedStart = true;
        communityContentVideoPlay(communityContentId, playerId, logData);
        trackInViewVideo && communityContentEnterView(communityContentId, playerId, logData);
      } else if (this.paused && !paused) {
        communityContentVideoPlay(communityContentId, playerId, logData);
      }

      this.paused = paused;

      if (adPlaying) {
        return;
      }

      if (currentTimeMs !== this.props.currentTimeMs && !this.hasLoggedStop) {
        communityContentVideoPositionUpdated(communityContentId, currentTimeMs, durationMs, logData);
      }

      this.duratitonWatchedMs += nextProps.currentTimeMs - this.props.currentTimeMs;

      // Log if video ends
      if (!this.props.ended && nextProps.ended) {
        this.onCommunityVideoStop(true, false, nextProps);
      }

      // Reset logging if restarting item in playlist
      if (this.props.isLastPlaylistItem && this.props.ended && !nextProps.ended) {
        this.resetLogging();
      }

      // Log and reset if changing playlist item
      if (this.props.playingIndex !== nextProps.playingIndex) {
        this.onCommunityVideoStop(false, false, this.props);
        this.resetLogging();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.onCommunityVideoStop(false, true);
      window.removeEventListener('beforeunload', this.onCommunityVideoStop);
    }
  }, {
    key: 'resetLogging',
    value: function resetLogging() {
      this.durationWatchedMs = 0;
      this.hasLoggedStop = false;
      this.hasLoggedStart = false;
      this.paused = false;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return PlaybackEventNotifier;
}(_react.Component);

PlaybackEventNotifier.propTypes = {
  playerId: _react.PropTypes.string.isRequired,
  currentTimeMs: _react.PropTypes.number.isRequired,
  durationMs: _react.PropTypes.number.isRequired,
  playingIndex: _react.PropTypes.number,
  logData: _react.PropTypes.object,
  ended: _react.PropTypes.bool.isRequired,
  isLastPlaylistItem: _react.PropTypes.bool.isRequired,
  adPlaying: _react.PropTypes.bool.isRequired,
  communityContentVideoPlay: _react.PropTypes.func.isRequired,
  communityContentVideoPositionUpdated: _react.PropTypes.func.isRequired,
  communityContentVideoStopped: _react.PropTypes.func.isRequired,
  communityContentEnterView: _react.PropTypes.func.isRequired,
  communityContentLeaveView: _react.PropTypes.func.isRequired,
  trackInViewVideo: _react.PropTypes.bool
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onCommunityVideoStop = function () {
    var isVideoComplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var shouldContinueVideo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var _ref = props || _this2.props,
        logData = _ref.logData,
        communityContentId = _ref.communityContentId,
        playerId = _ref.playerId,
        trackInViewVideo = _ref.trackInViewVideo,
        communityContentVideoStopped = _ref.communityContentVideoStopped,
        communityContentLeaveView = _ref.communityContentLeaveView,
        playingIndex = _ref.playingIndex;

    if (_this2.hasLoggedStop || !communityContentId) {
      return;
    }
    _this2.hasLoggedStop = true;

    communityContentVideoStopped(communityContentId, playerId, isVideoComplete, shouldContinueVideo && playingIndex === 0, _extends({}, logData, {
      durationWatchedInSeconds: Math.floor(_this2.durationWatchedMs / 1000, -1),
      isVideoComplete: isVideoComplete
    }));
    trackInViewVideo && communityContentLeaveView(communityContentId, playerId, logData);
  };
};

exports.default = PlaybackEventNotifier;